// extracted by mini-css-extract-plugin
module.exports = {"animationC":"animationC_animationC__PavpT"};